import axios from 'axios';
import { BASE_URL } from '@/global/util/constants';
import qs from 'qs'
const state = {};

const getters = {};

const mutations = {};

const actions = {
  async options ({ state, commit }, { platform, data }) { // 下拉菜单
    const response = await axios.post(`${BASE_URL}/${platform}/data/option`, data);
    return response.data
  },
  async table ({ state, commit }, { platform, data }) { // 汇总数据
    const response = await axios.get(`${BASE_URL}/${platform}/data/list`, {params: data});
    return response.data
  },
  async detail ({ state, commit }, { platform, data }) { // 详情数据
    const response = await axios.get(`${BASE_URL}/${platform}/data/detail`, {params: data});
    return response.data
  },
  async granularity ({ state, commit }, { platform, data } = {}) { // 下拉菜单
    const response = await axios.get(`${BASE_URL}/interface/etcd/item/granularity`, data);
    return response.data
  },
  async getCustomTags ({ state, commit }, { platform, data }) { // 详情数据
    const response = await axios.get(`${BASE_URL}/${platform}/data/custom_metrics_option`, {params: data});
    return response.data
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
